<template>
  <a-form-model
      ref="targetForm"
      :model="form"
      :rules="rules"
      :label-col="{span: 12}"
      :wrapper-col="{span: 12}"
  >
    <a-alert message="温馨提示：请注意您填写的信息仅适用于签证申请，请如实提供真实信息。" banner closable/>
    <a-card title="个人信息">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="姓(拼音)" prop="surname">
            <a-input v-model="form.surname" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="名(拼音)" prop="givenName">
            <a-input v-model="form.givenName" placeholder="例如 xinan"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="性别" prop="sex">
            <a-radio-group v-model="form.sex">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期" prop="birthday">
            <a-date-picker style="width: 100%" v-model.trim="form.birthday" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生城市" prop="cityOfBirth">
            <a-input v-model="form.cityOfBirth" placeholder="例如 广州"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="公民身份证号码" prop="nationalIdentificationNumber">
            <a-input v-model="form.nationalIdentificationNumber" placeholder="例如 xinan"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="地址与电话信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址省份" prop="homeAddressForProvince">
            <a-input placeholder="例如 广东" v-model="form.homeAddressForProvince"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址城市" prop="homeAddressForCity">
            <a-input placeholder="例如 广州" v-model="form.homeAddressForCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址" prop="homeAddressForStreet">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.homeAddressForStreet"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手机号" prop="primaryPhoneNumber">
            <a-input placeholder="例如 13900000000" v-model="form.primaryPhoneNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现用电子邮箱" prop="emailAddress">
            <a-input placeholder="例如 654431151@qq.com" v-model="form.emailAddress"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="在美联系人信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人名字" prop="namesForContactPerson">
            <a-input placeholder="例如 san" v-model="form.namesForContactPerson"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人州" prop="stateOfContact">
            <a-select v-model="form.stateOfContact" placeholder="请选择">
              <a-select-option v-for="item in stateList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人城市" prop="cityOfContact">
            <a-input v-model="form.cityOfContact" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人地址" prop="streetOfContact">
            <a-input v-model="form.streetOfContact" placeholder="例如 450 Serra Mall"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人电话" prop="phoneOfContact">
            <a-input v-model="form.phoneOfContact" placeholder="例如 3179978356"/>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-card>
    <a-card title="家庭信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲姓氏" prop="fatherSurnames">
            <a-input v-model="form.fatherSurnames" placeholder="例如 zhang"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲名字" prop="fatherGivenNames">
            <a-input v-model="form.fatherGivenNames" placeholder="例如 san"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲姓氏" prop="motherSurnames">
            <a-input v-model="form.motherSurnames" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲名字" prop="motherGivenNames">
            <a-input v-model="form.motherGivenNames" placeholder="例如 si"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="工作教育培训信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有工作" prop="haveEmployer">
            <a-radio-group v-model="form.haveEmployer">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.haveEmployer === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现工作单位" prop="primaryEmployerName">
            <a-input placeholder="例如 中科院" v-model="form.primaryEmployerName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位省份" prop="primaryOccupationForProvince">
            <a-input placeholder="例如 广东" v-model="form.primaryOccupationForProvince"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位城市" prop="primaryOccupationForCity">
            <a-input placeholder="例如 广州" v-model="form.primaryOccupationForCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位地址" prop="primaryOccupationStreet">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.primaryOccupationStreet"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="国内紧急联系人" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="紧急联系人姓氏" prop="emergencySurname">
            <a-input v-model="form.emergencySurname" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="紧急联系人名字" prop="emergencyGivenName">
            <a-input v-model="form.emergencyGivenName" placeholder="例如 xinan"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="紧急联系人邮箱" prop="emergencyEmail">
            <a-input v-model="form.emergencyEmail" placeholder="例如 654431151@qq.com"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="紧急联系人国内号码" prop="emergencyPhone">
            <a-input v-model="form.emergencyPhone" placeholder="例如 16507232300"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
  </a-form-model>
</template>

<script>
import moment from "moment";
import {HttpMixins} from "@/mixins/http-mixins";

const pattern = {
  english: /^[a-zA-Z\s]+$/,
  chinese: /^([\u4E00-\u9FA5]+)$/,
  numberOrChinaOrEnglish: /^([\u4E00-\u9FA5\w\- ]+)$/,
  nationalIdentificationNumber: /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)$/,
  phone: /^(1[345789]\d{9})$/,
  mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  usaPhone: /^((1)?[2-9]\d{2}[2-9](?!11)\d{6})$/,
}

export default {
  name: "DetailCreateTable",
  mixins: [HttpMixins],
  data() {
    return {
      moment,
      model: {},
      form: {},
      rules: {
        surname: [
          {required: true, pattern: pattern.english, message: '输入有误,a-z'},
        ],
        givenName: [
          {required: true, pattern: pattern.english, message: '输入有误,a-z'},
        ],
        sex: [{required: true, message: '必填!'}],
        birthday: [
          {required: true, message: '必填!'}
        ],
        cityOfBirth: [{required: true, pattern: pattern.numberOrChinaOrEnglish, message: '必填,数字中文英文空格或_'}],
        nationalIdentificationNumber: [{
          required: true,
          pattern: pattern.nationalIdentificationNumber,
          message: '必填,身份证格式!'
        }],
        homeAddressForProvince: [{
          required: true,
          pattern: pattern.numberOrChinaOrEnglish,
          message: '必填,数字中文英文空格或_'
        }],
        homeAddressForCity: [{
          required: true,
          pattern: pattern.numberOrChinaOrEnglish,
          message: '必填,数字中文英文空格或_'
        }],
        homeAddressForStreet: [{
          required: true,
          pattern: pattern.numberOrChinaOrEnglish,
          message: '必填,数字中文英文空格或_'
        }],
        primaryPhoneNumber: [{
          required: true,
          pattern: pattern.phone,
          message: '必填,请输入正确格式手机号!'
        }],
        emailAddress: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        namesForContactPerson: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        stateOfContact: [{required: true, message: '必填!'}],
        cityOfContact: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        streetOfContact: [{
          required: true,
          pattern: pattern.englishAddress,
          message: '必填,英文,单词之间只有一个空格!'
        }],
        phoneOfContact: [{required: true, pattern: pattern.usaPhone, message: '必填,美国手机号码!'}],
        fatherSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        fatherGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        motherSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        motherGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        haveEmployer: [{required: true, message: '必填!'}],
        primaryEmployerName: [{
          required: true,
          pattern: pattern.numberOrChinaOrEnglish,
          message: '必填,数字中文英文空格或_'
        }],
        primaryOccupationForProvince: [{
          required: true,
          pattern: pattern.numberOrChinaOrEnglish,
          message: '必填,数字中文英文空格或_'
        }],
        primaryOccupationForCity: [{
          required: true,
          pattern: pattern.numberOrChinaOrEnglish,
          message: '必填,数字中文英文空格或_'
        }],
        primaryOccupationStreet: [{
          required: true,
          pattern: pattern.numberOrChinaOrEnglish,
          message: '必填,数字中文英文空格或_'
        }],
        emergencySurname: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        emergencyGivenName: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        emergencyEmail: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        emergencyPhone: [{required: true, pattern: pattern.phone, message: '必填,手机号码!'}],

      },
      stateList: [
        {name: 'CALIFORNIA', value: '加州'},
        {name: 'NEW YORK', value: '纽约'},
        {name: 'WASHINGTON', value: '华盛顿'},
        {name: 'DISTRICT OF COLUMBIA', value: '哥伦比亚特区'},
        {name: 'FLORIDA', value: '佛罗里达'},
        {name: 'GEORGIA', value: '乔治亚州'},
        {name: 'TEXAS', value: '德州'},
        {name: 'OREGON', value: '俄勒冈州'},
        {name: 'PENNSYLVANIA', value: '宾西法尼亚'},
        {name: 'MASSACHUSETTS', value: '麻萨诸塞州'},
        {name: 'ALABAMA', value: '阿拉巴马州'},
        {name: 'ALASKA', value: '阿拉斯加'},
        {name: 'AMERICAN SAMOA', value: '美属萨摩亚'},
        {name: 'ARIZONA', value: '亚利桑那州'},
        {name: 'ARKANSAS', value: '阿肯色州'},
        {name: 'COLORADO', value: '科罗拉多州'},
        {name: 'CONNECTICUT', value: '康涅狄格'},
        {name: 'DELAWARE', value: '特拉华州'},
        {name: 'GUAM', value: '关岛'},
        {name: 'HAWAII', value: '夏威夷'},
        {name: 'IDAHO', value: '爱达荷州'},
        {name: 'ILLINOIS', value: '伊利诺斯州'},
        {name: 'INDIANA', value: '印第安纳州'},
        {name: 'IOWA', value: '爱荷华州'},
        {name: 'KANSAS', value: '堪萨斯'},
        {name: 'KENTUCKY', value: '肯塔基州'},
        {name: 'LOUISIANA', value: '路易斯安那州'},
        {name: 'MAINE', value: '缅因州'},
        {name: 'MARYLAND', value: '马里兰'},
        {name: 'MICHIGAN', value: '密歇根'},
        {name: 'MINNESOTA', value: '明尼苏达州'},
        {name: 'MISSISSIPPI', value: '密西西比州'},
        {name: 'MISSOURI', value: '密苏里州'},
        {name: 'MONTANA', value: '蒙大拿'},
        {name: 'NEBRASKA', value: '内布拉斯加州'},
        {name: 'NEVADA', value: '内华达'},
        {name: 'NEW HAMPSHIRE', value: '新汉普郡'},
        {name: 'NEW JERSEY', value: '新泽西'},
        {name: 'NEW MEXICO', value: '新墨西哥'},
        {name: 'NORTH CAROLINA', value: '北卡罗莱纳'},
        {name: 'NORTH DAKOTA', value: '北达科他'},
        {name: 'NORTHERN MARIANA ISLANDS', value: '北马里亚纳群岛'},
        {name: 'OHIO', value: '俄亥俄州'},
        {name: 'OKLAHOMA', value: '俄克拉何马州'},
        {name: 'PUERTO RICO', value: '波多黎各'},
        {name: 'RHODE ISLAND', value: '罗德岛州'},
        {name: 'SOUTH CAROLINA', value: '南卡罗来纳'},
        {name: 'SOUTH DAKOTA', value: '南达科塔州'},
        {name: 'TENNESSEE', value: '田纳西州'},
        {name: 'UTAH', value: '犹他州'},
        {name: 'VERMONT', value: '佛蒙特州'},
        {name: 'VIRGIN ISLANDS', value: '属维尔京群岛'},
        {name: 'VIRGINIA', value: '维吉尼亚州'},
        {name: 'WEST VIRGINIA', value: '西维吉尼亚州'},
        {name: 'WISCONSIN', value: '威斯康辛州'},
      ],
      url: {
        draftSave: window._CONFIG['domainURL'] + "/power/usEvus/draftSave",
        complement: window._CONFIG['domainURL'] + "/usEvus/complement",
      }
    }
  },
  methods: {
    init(data) {
      this.$refs.targetForm.resetFields();
      this.model = Object.assign({}, data);
      this.form = {};
      if (this.model.content) {
        this.form = JSON.parse(this.model.content);
      }
    },
    handleDraft() {
      const that = this;
      let param = {
        id: that.model.id,
        content: JSON.stringify(that.form)
      }
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.$emit('completeDraft');
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.put(that.url.draftSave, param, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess));
    },
    handleValid() {
      this.$refs.targetForm.validate((valid) => {
        if (valid) {
          this.$message.success("验证通过")
          return;
        }
        this.$message.warning("验证不通过")
      })
    },
    handleSubmit() {
      const that = this;
      this.$refs.targetForm.validate((valid) => {
        if (valid) {
          that.$emit('before');
          let param = {
            id: that.model.id,
            content: JSON.stringify(that.form)
          }

          const handleSuccess = (res) => {
            if (res) {
              let response = res.data;
              if (response.code === 200) {
                that.$emit('complete', that.model.id);
              } else {
                that.$message.error(response.msg);
              }
            }
          };

          that.$axios.put(that.url.complement, param, {headers: that.headers})
              .then(handleSuccess)
              .catch((error) => that.catchError(error).then(handleSuccess))
              .finally(() => {
                that.$emit('finally');
              });
        } else {
          that.$message.warning("验证不通过")
        }
      })
    },
    afterNow(current) {
      return current && current > moment().startOf('day');
    },

  }
}
</script>

<style scoped>

</style>
